namespace GeniuzPOS.Inventory {
    export interface IcStockReceiveForm {
        SysDocNo: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        RefDocNo1: Serenity.StringEditor;
        RefDocNo2: Serenity.StringEditor;
        WhsId: Serenity.LookupEditor;
        StockFrom: Serenity.LookupEditor;
        PostFg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
        Remark: Serenity.TextAreaEditor;
        ReceiveDtList: IcStockReceiveDtEditor;
    }

    export class IcStockReceiveForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IsStockReceive';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockReceiveForm.init)  {
                IcStockReceiveForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = s.EnumEditor;
                var w4 = s.TextAreaEditor;
                var w5 = IcStockReceiveDtEditor;

                Q.initFormType(IcStockReceiveForm, [
                    'SysDocNo', w0,
                    'DocNo', w0,
                    'DocDate', w1,
                    'RefDocNo1', w0,
                    'RefDocNo2', w0,
                    'WhsId', w2,
                    'StockFrom', w2,
                    'PostFg', w3,
                    'CancelFg', w3,
                    'Remark', w4,
                    'ReceiveDtList', w5
                ]);
            }
        }
    }
}
